export const PRODUCTION_HOSTNAME = "astrologer.astrocall.live";
export const PRODUCTION_API_BASE = "https://api.astrocall.live/api/";
export const DEVELOPMENT_API_BASE = "http://liveapi.astrocall.live/api/";

export function normalizeApiBaseUrl(baseUrl) {
  if (!baseUrl) return "";
  return baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
}

export function isLocalDevHost(hostname) {
  if (!hostname) return false;
  const host = String(hostname).toLowerCase().split(":")[0];
  return host === "localhost" || host === "127.0.0.1";
}

/**
 * Production (any non-local host, including astrologer.astrocall.live)
 * must always use HTTPS API to avoid Mixed Content on HTTPS pages.
 * Only localhost / 127.0.0.1 use the development API.
 */
export function getApiBaseUrl() {
  if (typeof window === "undefined") {
    return normalizeApiBaseUrl(DEVELOPMENT_API_BASE);
  }

  if (isLocalDevHost(window.location.hostname)) {
    return normalizeApiBaseUrl(DEVELOPMENT_API_BASE);
  }

  return normalizeApiBaseUrl(PRODUCTION_API_BASE);
}

export function buildApiUrl(pathOrUrl, baseUrl = getApiBaseUrl()) {
  if (!pathOrUrl) return normalizeApiBaseUrl(baseUrl);
  if (String(pathOrUrl).startsWith("http")) return pathOrUrl;

  const base = normalizeApiBaseUrl(baseUrl);
  const path = String(pathOrUrl).replace(/^\/+/, "");

  if (base.startsWith("/")) {
    return `${base}${path}`;
  }

  try {
    return new URL(path, base).toString();
  } catch (error) {
    console.error("buildApiUrl failed:", { pathOrUrl, baseUrl: base, error });
    return `${base}${path}`;
  }
}
